var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8583 1.93164H4.28683C2.70887 1.93164 1.42969 3.21083 1.42969 4.78878V36.2174C1.42969 37.7954 2.70887 39.0745 4.28683 39.0745H30.0011C31.5791 39.0745 32.8583 37.7954 32.8583 36.2174V23.3602M1.42969 30.5031H32.8583M10.0011 9.0745H15.7154M10.0011 16.2174H12.8583M25.6987 21.9482L17.1272 23.4911L18.5558 14.8054L30.6414 2.77678C30.9071 2.50898 31.2231 2.29643 31.5714 2.15137C31.9194 2.00632 32.2928 1.93164 32.67 1.93164C33.0474 1.93164 33.4208 2.00632 33.7688 2.15137C34.1171 2.29643 34.4331 2.50898 34.6985 2.77678L37.7271 5.80536C37.9951 6.07096 38.2077 6.38695 38.3525 6.73513C38.4977 7.0833 38.5723 7.45676 38.5723 7.83393C38.5723 8.2111 38.4977 8.58455 38.3525 8.9327C38.2077 9.28087 37.9951 9.5969 37.7271 9.8625L25.6987 21.9482Z",
    stroke: "#0E9349",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.0e49bc052b79f29cd41bc473dc0c628f.svg";
export { ForwardRef as ReactComponent };